import { ComponentsOverrides, ComponentsProps, Theme } from "@mui/material";
import { ciCustomColors } from "./colors";

type MuiCard = {
  defaultProps?: ComponentsProps["MuiCard"];
  styleOverrides: ComponentsOverrides<Theme>["MuiCard"];
};

const muiCard: MuiCard = {
  defaultProps: {
    variant: "outlined",
  },
  styleOverrides: {
    root: ({ ownerState }) => ({
      ...(ownerState.variant === "outlined" && {
        border: `2px solid ${ciCustomColors.blue[50]}`,
        borderRadius: "4px",
      }),
    }),
  },
};

export default muiCard;
